export default __webpack_public_path__ + "static/media/khrom.e2e4a214.svg";